import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../static/media/logo.webp";

export default function Login() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((previous) => ({
      ...previous,
      [name]: value,
    }));

    setMessage("");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const email = formData.email.trim().toLowerCase();
    const password = formData.password;

    if (!email || !password) {
      setMessage("Completa el correo y la contraseña.");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const response = await fetch("/api/web/login/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          password,
        }),
      });

      const data = await response.json();

      if (!response.ok || !data.ok) {
        throw new Error(data.message || "No fue posible iniciar sesión.");
      }

      if (
        data.user?.user_type !== "SUPERADMIN" ||
        data.user?.is_superuser !== true
      ) {
        throw new Error("No tienes acceso.");
      }

      localStorage.setItem("admin_access_token", data.access);
      localStorage.setItem("admin_refresh_token", data.refresh);
      localStorage.setItem("admin_user", JSON.stringify(data.user));

      localStorage.removeItem("user_access_token");
      localStorage.removeItem("user_refresh_token");
      localStorage.removeItem("user_data");

      navigate("/admin-panel", {
        replace: true,
      });
    } catch (error) {
      localStorage.removeItem("admin_access_token");
      localStorage.removeItem("admin_refresh_token");
      localStorage.removeItem("admin_user");

      setMessage(
        error instanceof Error
          ? error.message
          : "No fue posible conectar con el servidor."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        backgroundColor: "#f4f4f5",
      }}
    >
      <Box
        sx={{
          display: {
            xs: "none",
            md: "flex",
          },
          width: "50%",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#000000",
          padding: 7,
          borderRight: "5px solid #b00020",
        }}
      >
        <Box sx={{ width: "100%", maxWidth: 480 }}>
          <Box
            component="img"
            src={logo}
            alt="AccessHub"
            sx={{
              width: 115,
              height: 115,
              objectFit: "contain",
              marginBottom: 3,
            }}
          />

          <Typography
            component="h1"
            sx={{
              color: "#ffffff",
              fontSize: 46,
              fontWeight: 800,
              lineHeight: 1.1,
              marginBottom: 2,
            }}
          >
            AccessHub
          </Typography>

          <Typography
            sx={{
              maxWidth: 430,
              color: "#b8b8bd",
              fontSize: 16,
              lineHeight: 1.7,
              fontWeight: 500,
            }}
          >
            Gestión central de organizaciones y servicios.
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          width: {
            xs: "100%",
            md: "50%",
          },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 3,
        }}
      >
        <Paper
          elevation={0}
          sx={{
            width: "100%",
            maxWidth: 440,
            padding: {
              xs: 3,
              sm: 5,
            },
            border: "1px solid #e1e1e4",
            borderTop: "4px solid #b00020",
            borderRadius: 3,
          }}
        >
          <Box
            component="img"
            src={logo}
            alt="AccessHub"
            sx={{
              display: {
                xs: "block",
                md: "none",
              },
              width: 78,
              height: 78,
              objectFit: "contain",
              margin: "0 auto 24px",
            }}
          />

          <Typography
            component="h2"
            sx={{
              color: "#111111",
              fontSize: 29,
              fontWeight: 800,
              marginBottom: 1,
            }}
          >
            Iniciar sesión
          </Typography>

          <Typography
            sx={{
              color: "#6b7280",
              fontSize: 14,
              fontWeight: 500,
              marginBottom: 4,
            }}
          >
            Ingresa tus credenciales.
          </Typography>

          {message && (
            <Alert severity="error" sx={{ marginBottom: 3 }}>
              {message}
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit}>
            <TextField
              fullWidth
              required
              name="email"
              type="email"
              label="Correo"
              value={formData.email}
              onChange={handleChange}
              autoComplete="username"
              disabled={loading}
              sx={{ marginBottom: 2 }}
            />

            <TextField
              fullWidth
              required
              name="password"
              type="password"
              label="Contraseña"
              value={formData.password}
              onChange={handleChange}
              autoComplete="current-password"
              disabled={loading}
            />

            <Button
              fullWidth
              type="submit"
              variant="contained"
              disabled={loading}
              sx={{
                minHeight: 44,
                marginTop: 3,
                borderBottom: "3px solid #b00020",
              }}
            >
              {loading ? (
                <CircularProgress size={22} sx={{ color: "#ffffff" }} />
              ) : (
                "Ingresar"
              )}
            </Button>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
}